<div class="dialog-form-scoring">
  <header class="dialog-form-scoring__header">
    <div class="dialog-form-scoring__heading">
      <ui-atom-text type="title" [text]="'beneficiaryDetail.forms.scoringTitle' | translate"></ui-atom-text>
      <ui-atom-text
        type="medium"
        [text]="data.formName"
        class="dialog-form-scoring__form-name"
      ></ui-atom-text>
    </div>
    <button
      type="button"
      class="dialog-form-scoring__expand"
      [attr.aria-label]="isExpanded ? 'Collapse dialog' : 'Expand dialog'"
      (click)="toggleExpanded()"
    >
      <mat-icon>{{ isExpanded ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    </button>
  </header>

  <main class="dialog-form-scoring__body">
    @if (surveyModel) {
      <survey [model]="surveyModel"></survey>
    }
  </main>

  <footer class="dialog-form-scoring__footer">
    <ui-atom-button
      type="button"
      rules="main"
      styling="outlined"
      [withShadow]="false"
      [text]="'buttons.close' | translate"
      (buttonClick)="onClose()"
    ></ui-atom-button>
  </footer>
</div>
